import { render, staticRenderFns } from "./AssemblyStepItems.vue?vue&type=template&id=296cd23b&scoped=true&"
import script from "./AssemblyStepItems.vue?vue&type=script&lang=js&"
export * from "./AssemblyStepItems.vue?vue&type=script&lang=js&"
import style0 from "./AssemblyStepItems.vue?vue&type=style&index=0&id=296cd23b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296cd23b",
  null
  
)

export default component.exports